var React = require('react');

function Sneakers (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.832031 18.3334V16.0089C0.832031 15.3035 1.2708 14.6645 1.9233 14.408C2.53452 14.174 3.10322 13.8366 3.62568 13.4431C4.21745 12.9973 4.72628 12.4379 5.1491 11.8172L6.66536 13.3334L7.4987 12.5001L5.7604 10.7618C5.94999 10.3741 6.11041 9.97547 6.24107 9.57579L8.33203 11.6667L9.16536 10.8334L6.56838 8.23643C6.63282 7.83774 6.66536 7.44982 6.66536 7.08342L7.91536 6.25008L9.16536 7.50008L11.2487 5.41675L11.2487 2.91675L12.4987 1.66675L19.1654 8.33342L15.832 11.6667H14.1654L13.332 12.5001L12.9154 14.5834L9.16537 18.3334H0.832031Z","fill":"#343A40"}));
}

Sneakers.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Sneakers;

Sneakers.default = Sneakers;
